/** @module SiteAdmin/Lookup/NewSpecificationItem */
define([
	"dojo/_base/declare",
	"csi",
	"csi/reflection",
	"csi/table/New",
	"./SpecificationItemMixin"
], function(declare,csi,reflection,New,SpecificationItemMixin) {

	return declare([New,SpecificationItemMixin], {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: fix type based on switchboard
			if (this.widget.urlSubtype != csi.EMPTY_URL) {
				view.addFixedValue(reflection.ATTR_SUBTYPE, this.widget.urlSubtype);
			}

			this.inherited(arguments);
		}
	});
});